import { HuitabModal } from '../../../../shared/components/common/huitab-modal';

export class ModalConfirmationTelechargementInterlocuteurs extends HuitabModal {
  /**
   * Initialise une nouvelle instance de type {@type ModalConfirmationTelechargementInterlocuteurs}.
   */
  constructor() {
    super('modal-confirmation-telechargement-interlocuteurs');
  }
}
